import { lazy } from '@/service/lazy'

export default [{
  name: 'Assinaturas',
  path: 'assinatura',
  id: 'assinatura',
  icon: 'fa fa-money',
  component: lazy('app/default/adm_financeiro/assinatura/index'),
  meta: { requireAuth: true, rules: ['gerenciar_assinaturas'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/assinatura.js